import { PHONE_DISPLAY, PHONE_TEL } from "@/pages/home/constants";

const facts = [
  {
    icon: "ri-map-pin-2-line",
    label: "Museo del Zócalo, Local 408",
    href: undefined as string | undefined,
  },
  {
    icon: "ri-time-line",
    label: "Todos los días 10:30 a. m. – 6:30 p. m.",
    href: undefined as string | undefined,
  },
  {
    icon: "ri-phone-line",
    label: PHONE_DISPLAY,
    href: PHONE_TEL,
  },
  {
    icon: "ri-graduation-cap-line",
    label: "Te enseñamos a jugar antes de comprar",
    href: undefined as string | undefined,
  },
];

export default function QuickInfo() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-content grid-cols-2 gap-3 px-4 py-8 md:grid-cols-4 md:gap-5 md:px-6 md:py-10">
        {facts.map((fact) => {
          const inner = (
            <div className="flex h-full flex-col items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                <i className={`${fact.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="text-sm font-label font-semibold leading-snug text-foreground-900">
                {fact.label}
              </span>
            </div>
          );

          return fact.href ? (
            <a key={fact.label} href={fact.href} className="cursor-pointer">
              {inner}
            </a>
          ) : (
            <div key={fact.label}>{inner}</div>
          );
        })}
      </div>
    </section>
  );
}